import { Validation } from '../../services/model-service';
import EventData from '../event/event-data';
import EventListener from '../event/event-listener';

import Mountable from './mountable';

interface ChangeEventArgs {
  entry?: string;
  oldValue: any;
  validations?: Validation[];
  value: any;
}

class ChangeEvent<T> extends EventData<Changeable<T>> implements ChangeEventArgs {
  entry?: string;
  oldValue: T | undefined;
  validations?: Validation[];
  value: T;

  constructor({ entry, oldValue, validations, value }: ChangeEventArgs) {
    super();
    this.entry = entry;
    this.value = value;
    this.oldValue = oldValue;
    this.validations = validations;
  }
}

class ChangeEventListener<T> extends EventListener<Changeable<T>, ChangeEvent<T>, ChangeEventArgs> {

  constructor() {
    super(ChangeEvent);
  }
}

export default interface Changeable<T> extends Mountable {

  /** @event */
  onChange: ChangeEventListener<T>;

  getValue(): T | undefined;
  setValue(value: T): void;
}

export { ChangeEventListener, ChangeEvent };
